import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=f74654ae&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=js"
export * from "./ProductFinder.vue?vue&type=script&lang=js"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=f74654ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74654ae",
  null
  
)

export default component.exports